import { CHECKLIST_COMPLETION_STATE } from 'src/constants/tasksV2';
import { parseApiDate } from 'src/utils/taskDateUtils';

const toArray = (value) => (Array.isArray(value) ? value : []);

export function getTaskChecklistItems(task) {
    return toArray(task?.checklist_items || task?.checklist);
}

export function getEarliestPausedItem(items) {
    return toArray(items)
        .filter((item) => item?.completion_state === CHECKLIST_COMPLETION_STATE.PAUSED)
        .sort((a, b) => (parseApiDate(a.paused_until)?.valueOf() || 0) - (parseApiDate(b.paused_until)?.valueOf() || 0))[0] || null;
}

export function getTaskPauseState(task) {
    const items = getTaskChecklistItems(task);
    const pausedItem = getEarliestPausedItem(items);
    const hasPending = items.some((item) =>
        (item?.completion_state || CHECKLIST_COMPLETION_STATE.PENDING) === CHECKLIST_COMPLETION_STATE.PENDING
    );
    const isChecklistPaused = Boolean(pausedItem) && !hasPending;
    const isTaskPaused = task?.status === 'paused';
    const pauseSource = pausedItem || (isTaskPaused ? task : null);
    const pausedUntil = pausedItem?.paused_until || task?.resume_at || task?.paused_until || null;

    return {
        isPaused: isChecklistPaused || isTaskPaused,
        isChecklistPaused,
        isTaskPaused,
        pauseSource,
        pausedUntil,
    };
}

export function getLeadTreatmentIdFromTaskLike(value) {
    if (!value) return null;
    if (value.leadTreatment != null) return value.leadTreatment;
    if (value.lead_treatment_id != null) return value.lead_treatment_id;
    if (value.lead_treatment != null) {
        return typeof value.lead_treatment === 'object' ? value.lead_treatment.id : value.lead_treatment;
    }
    return null;
}

export function isInLeadTreatmentScope(value, leadTreatmentId, { includeUnscoped = false } = {}) {
    if (leadTreatmentId == null || leadTreatmentId === '') return true;
    const itemTreatmentId = getLeadTreatmentIdFromTaskLike(value);
    if (itemTreatmentId == null || itemTreatmentId === '') return includeUnscoped;
    return String(itemTreatmentId) === String(leadTreatmentId);
}
